import BaseComponent from '../base-component/base-component'

class LoginComponent extends BaseComponent {
  forms: Element[]

  constructor() {
    super()

    this.forms = [...this.querySelectorAll('[data-login-form]')]
  }

  connectedCallback(): void {
    this.updateFocus()

    this.addEventListener('click', this.handleClick)
  }

  disconnectedCallback(): void {
    this.removeEventListener('click', this.handleClick)
  }

  handleClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement
    const isLoginFormButton = target.hasAttribute('data-login-form-button')

    if (isLoginFormButton) {
      const loginFormId = target.dataset.loginFormId || ''

      this.setFormVisibleById(loginFormId)

      this.updateFocus()
    }
  }

  setFormVisibleById(loginFormId: string): void {
    this.forms.forEach(form => {
      const isTargetForm = form.getAttribute('data-login-form') === loginFormId

      form.classList.toggle('hidden', !isTargetForm)
    })
  }

  updateFocus(): void {
    this.forms.forEach(form => {
      const isHidden = form.classList.contains('hidden')
      const emailInput = form.querySelector(
        '[type="email"]',
      ) as HTMLInputElement

      if (!isHidden && emailInput) {
        emailInput.focus()
      }
    })
  }
}

export default LoginComponent
